<template>
  <div class="detail">
    <div class="detail__banner">
      <!-- <div v-if="imgLoaded" class="detail__banner__action">
        <div class="detail__banner__action__viewphoto">
          <button class="btn-regular secondary" @click="toggle">
            View Photos
          </button>
        </div>
        <div class="detail__banner__action__saveMobile">
          <button class="btn-small secondary" @click.stop="addRemoveDevice(deviceId)">
            <adx-loading-circle v-if="savedLoading" />
            <i v-if="!savedLoading" :class="iconSelection(deviceId)"></i>
          </button>
        </div>
      </div> -->
      <adx-detail-slider :slide="3" :isCenterMobile="true" :arrowMobile="false" :data="detailSlider" />
    </div>
    <div v-if="!infoLoaded" class="loading-container">
      <adx-loading />
    </div>
    <div v-else class="detail__info">
      <div class="detail__info__left">
        <div class="detail__info__left__header">
          <span class="detail__info__left__header--type subhead" v-if="location.airport">{{location.type}} • {{location.airport.airport_name}}</span>
          <span class="detail__info__left__header--type subhead" v-else>{{location.type}}</span>
          <h2 class="large-title">{{location.title}}</h2>
          <span class="detail__info__left__header--placement subhead">Placement : {{location.placement}}</span>
        </div>
        <div class="detail__info__left__subheader">
          <div v-if="isAudienceDisplayed" class="detail__info__left__subheader--info">
            <i class="icon-people"></i>
            <span>{{location.dailyVisitor}} daily visitor </span>
          </div>
          <div class="detail__info__left__subheader--info">
            <i class="icon-desktop"></i>
            <span>{{location.specification}} </span>
          </div>
          <div class="detail__info__left__subheader--info">
            <i class="icon-time"></i>
            <span>{{location.playback}} playback / day</span>
          </div>
          <div v-if="location.audio" class="detail__info__left__subheader--info">
            <i class="icon-volume-high"></i>
            <span>Allow audio support</span>
          </div>
        </div>
        <div class="detail__info__left__forbiddenMobile">
          <h3 class="title">
            <i class="icon icon-warning"></i>
            Forbidden Advertisement
          </h3>
          <p class="content small-font">{{location.forbidden}}</p>
        </div>
        <div v-if="demographics.length != 0" class="detail__info__left__demographic">
          <div class="detail__info__left__demographic__title">
            <h2 class="regular-font">Visitor Demographic</h2>
          </div>
          <div class="detail__info__left__demographic__content">
            <div class="detail__info__left__demographic__content--item" v-for="(demographic, index) in demographics" :key="index">
              <i :class="demographic.icon"></i>
              <span class="subhead">{{demographic.text}}</span>
            </div>
          </div>
        </div>
        <div class="detail__info__left__about">
          <div class="detail__info__left__about__title">
            <h2 class="regular-font">About the listing</h2>
          </div>
          <div class="detail__info__left__about__content">
            <p class="subhead">{{location.description}}</p>
          </div>
        </div>
        <div class="detail__info__left__operatinghour">
          <div class="detail__info__left__operatinghour__title">
            <h2 class="regular-font">Operation Hours</h2>
          </div>
          <div class="detail__info__left__operatinghour__content">
            <div class="detail__info__left__operatinghour__content--item" v-for="(operatinghour, index) in OperatingHours" :key="index">
              <span class="days">{{operatinghour.day}}</span>
              <span :class="['times', operatinghour.isOpen ? '' : 'day-close', 'subhead']">{{operatinghour.time}}</span>
            </div>
          </div>
        </div>
        <div class="detail__info__left__listingaddress">
          <div class="detail__info__left__listingaddress__title">
            <h2 class="regular-font">Listing Address</h2>
          </div>
          <div class="detail__info__left__listingaddress__content">
            <p class="subhead">
              {{location.address}}
            </p>
          </div>
        </div>
      </div>
      <div class="detail__info__right">
        <div class="detail__info__right__price">
          <h4 class="subhead title">Price per day</h4>
          <h3 class="medium-title price">{{location.price|formatMoney}}</h3>
        </div>
        <div class="detail__info__right__forbidden">
          <div class="detail__info__right__forbidden--title">
            <i class="icon-warning"></i>
            <h3>Forbidden Advertisement</h3>
          </div>
          <div class="detail__info__right__forbidden--content">
            <p>{{location.forbidden}}</p>
          </div>
        </div>
        <div class="detail__info__right__action">
          <button class="btn-regular secondary save" @click.stop="addRemoveDevice({id: deviceId, location_name: location.title})" :disabled="savedLoading">
            <adx-loading-circle v-if="savedLoading" />
            <i v-if="!savedLoading" :class="iconSelection(deviceId)"></i>
            <span> {{savedText(deviceId)}}</span>
          </button>
          <button class="btn-regular primary add" @click="showCampaign">Add to Campaign</button>
        </div>
      </div>
    </div>
    <div v-if="infoLoaded" class="detail__footer">
      <div class="detail__footer__left">
        <p class="micro-font title">Price per day</p>
        <p class="medium-title price">{{location.price|formatMoney}}</p>
      </div>
      <div class="detail__footer__right">
        <button class="btn-small secondary detail__footer__right__plus" @click.stop="addRemoveDevice({id: deviceId, location_name: location.title})" :disabled="savedLoading">
            <adx-loading-circle v-if="savedLoading" />
            <i v-if="!savedLoading" :class="iconSelection(deviceId)"></i>
        </button>
        <button class="btn-regular btn-block primary" @click="showCampaign">Add to campaign</button>
      </div>
    </div>
    <adx-modal v-if="isOpen" @modal-close="toggle" :type="`full`" :color="`transparant`">
      <div slot="content" class="content">
        <adx-detail-slider :isImageShow="true" :slide="1" :arrowMobile="true" @current="getCurrent" @init="getCount" :data="detailSlider" />
        <div class="modal__wrapper__footer">
          <span class="left">Image {{currentSlide}} of {{countSlide}} </span> <span class="right"> - {{location.title}}</span>
        </div>
      </div>
    </adx-modal>
    <adx-modal v-if="isShownCampaign" :noTitle="isMobile == false" :noTitleTop="isMobile == true" @modal-close="isShownCampaign = false" :type="!isMobile ? 'small' : ''">
      <div class="detail__campaign" slot="content">
        <h2 class="small-title">Add to campaign</h2>
        <button class="btn-block primary" @click="createCampaignUntitled">
          Create new campaign
          <div class="primary__load">
            <adx-loading-spin v-if="isCreateCampaign" slot="loading"/>
          </div>
        </button>
        <div class="detail__campaign__break">
          <span>OR</span>
        </div>
        <h2 class="small-title">Add to current campaign</h2>
        <div class="load">
          <adx-loading v-if="isLoadingCampaign" slot="loading" />
        </div>
        <ul class="detail__campaign__list">
          <li v-for="(item, index) in campaigns" :key="index" @click="appendCampaign(item)" class="detail__campaign__list__item">
            <p> {{item.title}} </p>
            <div class="detail__campaign__list__item__load">
              <adx-loading-circle v-if="isLoadingAppend.includes(item.id)" slot="loading"/>
            </div>
          </li>
        </ul>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import DetailSlider from '@/components/Slider/DetailSlider'
import Modal from '@/components/Modal'
import LoadingSecondary from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import LoadingPrimary from '@/components/Loading/Primary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatNumber } from '@/lib/filter'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'adx-detail-page',
  components: {
    'adx-detail-slider': DetailSlider,
    'adx-modal': Modal,
    'adx-loading-circle': LoadingSecondary,
    'adx-loading-spin': LoadingSpin,
    'adx-loading': LoadingPrimary
  },
  props: {

  },
  data() {
    return {
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isMobile: window.innerWidth < 769,
      isShownCampaign: false,
      campaigns: [],
      category: 'airport',
      location: {
        title: ``,
        placement: ``,
        type: ``,
        price: ``,
        dailyVisitor: ``,
        address: ``,
        description: ``,
        specification: ``,
        playback: ``,
        forbidden: ``
      },
      detailSlider: [
        {url: '/img/notfound/img-placeholder_landscape.jpg'},
        {url: '/img/notfound/img-placeholder_landscape.jpg'},
        {url: '/img/notfound/img-placeholder_landscape.jpg'}
      ],
      OperatingHours: [],
      demographics: [
        {
          id: `spending`,
          icon: `adx-ic_cards`,
          text: ``
        },
        {
          id: `job`,
          icon: `adx-ic_briefcase`,
          text: ``
        },
        {
          id: `profile`,
          icon: `icon-knowledge-base`,
          text: ``
        },
      ],
      isOpen: false,
      currentSlide: 1,
      countSlide: null,
      pub_id: null,
      deviceId: null,
      imgLoaded: false,
      infoLoaded: false,
      savedLoading: false,
      isAudienceDisplayed: null
    }
  },
  computed: {
    ...mapGetters ({
      defaultSaved: 'default',
      token: 'token'
    }),
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    const { pub_id } = this.$route.params
    this.pub_id = pub_id
    this.loadData()
    this.loadImage()
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    showCampaign(){
      if (this.token) {
        this.isShownCampaign = true
        this.getCampaigns()
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            this.campaigns = response.data
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    appendCampaign(item) {
      if (this.isLoadingAppend.length == 0) {
        (async () => {
          this.isLoadingAppend.push(item.id)
          const data = {
            channel_name: 'idooh',
            channel_id: this.deviceId
          }
          const response = await api.patch(apiV2.campaignAddListing(item.id), data, { needToken: true })
          this.isLoadingAppend = []
          if (response.status == 200) {
            this.isShownCampaign = false
            this.$router.push({ path: `/${item.id}/campaign-editor` })
          } else {
            this.$notify({
              group: 'saved',
              title: 'Error',
              text: 'sorry something went wrong!',
              type: 'warn'
            });
          }
        })();
      }
    },
    createCampaignUntitled() {
      (async () => {
        this.isCreateCampaign = true
        const data = {
          campaign_channel: [
            {
              name: 'idooh',
              list_id: [this.deviceId]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isShownCampaign = false
          this.$router.push({ path: `/${response.data['data']['id']}/campaign-editor` })
        } else {
          this.error = response.data.error
        }
      })();
    },
    loadData () {
      (async () => {
        const { data } = await api.get(apiV2.deviceDetail(this.pub_id))
        this.mapData(data)
        this.infoLoaded = true
      })();
    },
    loadImage () {
      (async () => {
        const { data } = await api.get(apiV2.deviceDetailImages(this.pub_id))
        this.detailSlider = data.map(el => {
          return {
            id: el.id,
            url: el.image,
            thumbnail: el.thumbnail_720,
            is360: el.is_360,
            viewer_url: el.viewer_url
          }
        })
        this.imgLoaded = true
      })();
    },
    mapData (data) {
      this.deviceId = data.id
      this.location = {
        title: data.location_name,
        placement: data.placement,
        type: data.property_type_display,
        price: data.price,
        dailyVisitor: data.audience_daily,
        address: (data.address ? data.address : 'N/A'),
        description: data.description,
        audio: data.audio_support,
        specification: `
          ${data.device_size} - ${data.orientation}
        `.trim(),
        playback: data.playback,
        forbidden: (data.forbidden_ads ? data.forbidden_ads : 'There\'s no forbidden ads'),
        airport: data.airport ? data.airport : undefined
      }
      this.OperatingHours = data.operating_hours.map(el => {
        let data = {}
        data.day = el.day
        data.isOpen = el.is_open
        if (el.is_open) {
          data.time = `${el.start} - ${el.end}`
        } else {
          data.time = 'closed'
        }
        return data
      })
      this.demographics.map(el => {
        switch (el.id) {
          case `spending`:
            el.text = `Average Spending ${formatNumber(data.average_spending)} / ${data.subject_spending_display} / ${data.period_spending_display}`
            break;
          case `job`:
            if (data.profile) {
              el.text = `Occupation ${data.profile.job.join(`, `)}`
            }
            break;
          case `profile`:
            if (data.profile) {
              el.text = `Visitor Profile ${data.profile.ses.join(` `)}`
            }
            break;
        }
        return el
      })
      this.demographics = this.demographics.filter(element => element.text !== ``)
      this.isAudienceDisplayed = data.is_audience_displayed
    },
    addRemoveDevice(item) {
      (async () => {
        this.savedLoading = true
        let category = this.category
        const isLogin = this.token
        if(isLogin) {
          const { response, msg } = await this.$store.dispatch('addRemoveSaved', {item: item, category: category})
          const text = `${this.location.title} ${msg.text.slice(12)}`
          this.$notify({
            group: 'saved',
            title: msg.title,
            text: text,
            type: msg.type
          });
          this.savedLoading = false
        } else {
          const currentRoute = this.$route.path
          this.$router.push({name: 'signin', query: { next: currentRoute }})
        }
      })();
    },
    iconSelection(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token
      if(isLogin && listSaved){
        if (listSaved.includes(id)) {
          return 'adx-ic_check'
        } else {
          return 'adx-ic_plus'
        }
      } else {
        return 'adx-ic_plus'
      }
    },
    savedText(id) {
      const listSaved = this.defaultSaved[this.category]
      const isLogin = this.token
      if(isLogin && listSaved){
        if (listSaved.includes(id)) {
          return `Saved`
        } else {
          return `Save`
        }
      } else {
        return `Save`
      }
    },
    toggle() {
      this.isOpen = !this.isOpen
    },
    getCurrent(item) {
      this.currentSlide = item + 1
    },
    getCount(item) {
      this.countSlide = item
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~@/views/Detail/index.scss';
</style>

<style lang="scss">
@import '~@/styles/variables';
@import '~@/styles/mixins';

.modal__content .content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 10%;
}

@include breakpoint(md) {
  .modal__content .content {
    padding: 0 16px;
  }
}
</style>
